import { jsx as _jsx } from "react/jsx-runtime";
/**
 * `TableBody` renders the `<tbody>` element and will typically contain `TableRow` elements to define table data.
 */
export const TableBody = _ref => {
  let {
    children,
    ...tableBodyProps
  } = _ref;
  return /*#__PURE__*/_jsx("tbody", {
    role: "rowgroup",
    ...tableBodyProps,
    children: children
  });
};
export default TableBody;